export default "__VITE_ASSET__UVyVH0n$__"